import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { isSuperAdminUser } from "@/lib/placement";
import { reApi } from "@/lib/residentApi";

let pending = null;
const fetchCredits = () => (pending ||= reApi.get("/lesson-voice/credits").finally(() => setTimeout(() => { pending = null; }, 60000)));

/** Super-admin warning when ElevenLabs lesson-voice credits drop below 20% of the month. */
export function LessonCreditBanner() {
  const { user } = useAuth();
  const [c, setC] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("tea_credit_banner_hidden") === "1");
  const sa = isSuperAdminUser(user);
  useEffect(() => { if (sa) fetchCredits().then(setC).catch(() => {}); }, [sa]);
  if (!sa || hidden || !c?.low) return null;
  const msg = c.ok
    ? `Lesson voice credits are low: ${c.pct_left}% left this month (${c.left.toLocaleString()} characters). When they run out, lessons switch to the backup voice.`
    : "Couldn't check ElevenLabs credits. Lessons may be using the backup voice.";
  return (
    <div data-testid="lesson-credit-banner" className="w-full border-b border-amber-400/30 bg-amber-500/10 text-amber-100">
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10 py-2 flex items-center gap-3 text-sm">
        <AlertTriangle className="h-4 w-4 text-amber-300 shrink-0" />
        <span data-testid="lesson-credit-banner-text" className="flex-1">{msg}</span>
        <Link to="/admin/lesson-voice" data-testid="lesson-credit-banner-link" className="font-mono text-[10px] tracking-[0.2em] uppercase text-amber-300 hover:text-amber-200">Lesson voice</Link>
        <button type="button" aria-label="Hide" data-testid="lesson-credit-banner-close" onClick={() => { sessionStorage.setItem("tea_credit_banner_hidden", "1"); setHidden(true); }}
          className="text-amber-300/70 hover:text-amber-200"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
